
import Vue, { PropType } from 'vue'

import { IEntityReviewFull, IEntityReviewProps } from 'types/DTO/reviews'

export default Vue.extend({
  name: 'RPHReviewBlock',
  components: {
    RPHButton: () => import('rph/atoms/RPHButton/index.vue'),
    Heading: () => import('~/components/atoms/Heading.vue'),
    RPHReviewCard: () => import('rph/molecules/RPHReviewCard/index.vue'),
    RPHReviewForm: () => import('rph/molecules/RPHModals/RPHReviewForm/index.vue'),
    RPHModalWindow: () => import('rph/molecules/RPHModals/RPHModalWindow/index.vue'),
  },
  props: {
    entity: {
      type: Object as PropType<IEntityReviewProps>,
    },
    page: {
      type: String,
      default: 'pharmacy',
    },
  },
  computed: {
    isReview(): boolean {
      return this.$store.getters['rph-modals/reviewShow']
    },
    reviews(): IEntityReviewFull[] {
      return this.$store.getters['rph-reviews/reviews']
    },

    entityText() {
      switch (this.page) {
        case 'pharmacy':
          return 'У этой аптеки пока нет отзывов'
        case 'product':
          return 'У этого продукта пока нет отзывов'
        case 'institution':
          return 'У этого центра пока нет отзывов'
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('rph-modals/clearModals')
  },
})
